import { Pipe, PipeTransform } from '@angular/core';
import { AppPageTexts, getAppTexts } from '../i18n/app-text';
import { LanguageService } from '../services/language.service';

type LoaderTextKey = keyof AppPageTexts<'loaders'>;

@Pipe({
  name: 'loaderText',
  pure: false,
})
export class LoaderTextPipe implements PipeTransform {
  constructor(private readonly languageService: LanguageService) {}

  transform(key: LoaderTextKey | null | undefined): string {
    if (!key) {
      return '';
    }

    return getAppTexts('loaders', this.languageService.currentLang)[key];
  }
}
